/**
 * This is booth only atom.
 * Do not use this in home app.
 */
import { atom } from 'jotai';

import { Activity, ACTIVITY_MODES } from '@data';

import { activityIdAtom } from '../global/url';

export const currentActivityAtom = atom<Activity | null>(null);

export const isLiveFeedbackModeAtom = atom((get) => {
    const currentActivity = get(currentActivityAtom);
    if (!currentActivity?.mode) {
        return false;
    }
    return currentActivity.mode === ACTIVITY_MODES.LIVE_FEEDBACK;
});

export const isDefaultModeAtom = atom((get) => {
    const currentActivity = get(currentActivityAtom);
    if (!currentActivity?.mode) {
        return false;
    }
    return currentActivity.mode === ACTIVITY_MODES.DEFAULT;
});

export const isBallLessModeAtom = atom((get) => {
    const currentActivity = get(currentActivityAtom);
    if (!currentActivity?.mode) {
        return false;
    }
    return currentActivity.mode === ACTIVITY_MODES.BALLLESS;
});

export const currentActivityIdAtom = atom((get) => {
    return get(currentActivityAtom)?.id ?? -1;
});

export const isCurrentActivityAtom = atom((get) => {
    return get(activityIdAtom) === get(currentActivityIdAtom);
});
